// extracted by mini-css-extract-plugin
export default {"modal":"imageViewerStyle_modal__jitzT","show":"imageViewerStyle_show__QHR2O","img":"imageViewerStyle_img__1EWu7"};